import Link from '@material-ui/core/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { useMemo } from 'react';
import VerifiedBadge from '@dev-togetherprice/components.verified-badge';
import TrustBadge from '@dev-togetherprice/components.trust-badge';
import LazyAvatar from '@dev-togetherprice/components.lazy-avatar';
const useStyles = makeStyles((theme) => ({
    root: {
        [theme.breakpoints.up('md')]: {
            cursor: ({ noClickable }) => (noClickable ? 'default' : 'pointer'),
            '-webkit-tap-highlight-color': 'transparent',
        },
        pointerEvents: 'all',
    },
    verified: ({ size }) => ({
        bottom: size / 5,
        right: size / 5,
        width: size / 3,
        height: size / 3,
    }),
}));
const AdminAvatar = ({ fullName, profileUrl, profilePictureUrl, verified = false, trust = 0, onClick, size = 88, lazyOptions = {}, eager, trustBadgeProps, }) => {
    const thickness = useMemo(() => {
        if (size <= 30)
            return 1;
        if (size <= 50)
            return 2;
        return 3;
    }, [size]);
    const avatarStyle = useMemo(() => ({
        width: '100%',
        height: '100%',
    }), []);
    const classes = useStyles({ size, noClickable: !onClick });
    const avatarImageProps = useMemo(() => ({
        // we are using ts-ignore otherwise typescript compiler throws missing type error weirdly
        loading: eager ? 'eager' : 'lazy',
        decoding: eager ? 'auto' : 'async',
    }), [eager]);
    return (React.createElement(Link, { component: 'div', role: 'link', href: profileUrl, "data-href": profileUrl, onClick: onClick, "aria-label": fullName, className: classes.root },
        React.createElement(VerifiedBadge, { size: 'custom', className: classes.verified, invisible: !verified },
            React.createElement(TrustBadge, Object.assign({ size: size, value: trust, thickness: thickness }, trustBadgeProps),
                React.createElement(LazyAvatar, { style: avatarStyle, src: profilePictureUrl, alt: fullName, imgProps: avatarImageProps, lazyOptions: lazyOptions })))));
};
export default AdminAvatar;
